import { callApi } from '../common/services/baseServices';
import { host } from '../environment';
import { getCookie } from '../common/enum';
// import { dataDummy } from './data';
import moment from 'moment';
import lodash from 'lodash';

const ACTIONS = {
    GET_TEAM_START_MEMBER_SUCCESS: 'GET_TEAM_START_MEMBER_SUCCESS',
    GET_TEAM_START_MEMBER_ERROR: 'GET_TEAM_START_MEMBER_ERROR',
    GET_TEAM_STARTER_SUCCESS: 'GET_TEAM_STARTER_SUCCESS',
    GET_TEAM_STARTER_ERROR: 'GET_TEAM_STARTER_ERROR'
};

const updateStatus = (type, data) => ({
    type,
    data,
});


const getTeamStartMember = (data) => {
    const config = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('ACCESS_TOKEN') || getCookie('ACCESS_TOKEN')}`,
        },
    };
    // team_id
    // year_id
    let url = `${host.serverTest}api/teams/${data.team_id}/years/${data.year_id}/results/summaries`;
    return (dispatch) => {
        callApi(url, config,
            (data) => {
                dispatch(updateStatus(ACTIONS.GET_TEAM_START_MEMBER_SUCCESS, data));
            },
            (err) => {
                dispatch(updateStatus(ACTIONS.GET_TEAM_START_MEMBER_ERROR, err));
            });
    };
};

const getTeamStarter = (data) => {
    const config = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('ACCESS_TOKEN') || getCookie('ACCESS_TOKEN')}`,
        },
    };
    // team_id
    // year_id
    // month_id
    let url = `${host.serverTest}api/teams/${data.team_id}/years/${data.year_id}/months/${data.month_id}/startings`;
    return (dispatch) => {
        callApi(url, config,
            (data) => {
                dispatch(updateStatus(ACTIONS.GET_TEAM_STARTER_SUCCESS, data));
            },
            (err) => {
                dispatch(updateStatus(ACTIONS.GET_TEAM_STARTER_ERROR, err));
            });
    };
};

const convertHeaderBatter = (data) => {
    let arrHeader = [];
    if (data.length) {
        data.forEach((value) => {
            arrHeader.push({text: value.batting_order});
        });

    }
    return arrHeader;
}

const convertItemsBatter = (data) => {
    let arr = [];
    let arrItems = [];
    if (data.length) {
        data.forEach((value) => {
            arrItems.push({
                text: value.player.player_name,
                position: value.position_name_s
            })
        });
    }
    arr.push({
        item: arrItems
    });
    return arr;
}

const convertPitchers = (data) => {
    let str = '';
    str = data.reduce((prev, current, index, arr) => {
        return (prev ? prev + ',　' : '') + current.player_name;
    }, '')
    return str;
}

const convertBackups = (data) => {
    let str = '';
    str = data.reduce((prev, current, index, arr) => {
        return (prev ? prev + ',　' : '') + current.player.player_name;
    }, '')
    return str;
}

const convertPitcherBackupOpponent = (data) => {
    const arrItems = [{
        item: [
            {
                text: convertPitchers(data.pitchers),
                position: data.pitchers[0] ? data.pitchers[0].position_type_s: ''
            },
            {
                text: convertBackups(data.pinch_hitters)
            },
            {
                text: convertBackups(data.pinch_runners)
            },
            {
                text: convertBackups(data.defences)
            },
            {
                text: data.opponent_pitcher.player_name,
                position: data.opponent_pitcher ? data.opponent_pitcher.position_type_s: ''
            }
        ]
    }];
    return arrItems;
}

const convertDataTeamStarter = (list) => {
    if (list) {
        list = lodash.sortBy(list, (obj) => {
            return new Date(obj.game_date);
        });
        const arr = list.map((value) => {
            const monthDay = moment(value.game_date).format('M/D（ddd）');
            return {
                titleTable: monthDay,
                headersBatter: convertHeaderBatter(value.batters),
                itemBatter: convertItemsBatter(value.batters),
                itemPitcherBackupOpponent: convertPitcherBackupOpponent(value)
            }
        });
        return arr;
    }
}

export {
    ACTIONS, getTeamStartMember, getTeamStarter, convertDataTeamStarter, convertPitcherBackupOpponent
};